export const DOWNLOAD_PAGE_PATH = "/download";

export const DOWNLOAD_URLS = {
  googlePlay: "https://play.google.com/store/apps/details?id=com.dz.fateuni",
  appStore: "",
  apk: "https://api.youzhi.net/client/dispatch.do?app=kkcpub&resource=fateuni&channel=google&versionCode=1&token=96a3e3082f7f168a9a056f8d1bbe2834",
};
